import { tabActions } from "../config/action-config";

const initialTab = { isClicked: false };

const tabReducer = (tab = initialTab, action) => {
  const { type } = action;
  switch (type) {
    case tabActions.CLICKED:
      return { isClicked: true };
    case tabActions.NOT_CLICKED:
      return { isClicked: false };

    default:
      return tab;
  }
};

export default tabReducer;
